import React from 'react';
import styled from 'styled-components';
import {
  Box,
  QuickLinkCard as QuickLinkCardFromLib,
} from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { RoutedLink } from 'shared/components';
import { QuickLinkCardConfig, QuickLinkCardProps } from './QuickLinkCardConfig';

const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    e.currentTarget.click();
  }
};

const QuickLinkCard = (props: QuickLinkCardProps) => {
  if (QuickLinkCardConfig.isEmpty(props)) {
    return null;
  }

  const QuickRoutedLink = styled(RoutedLink)`
    border: none;
  `;

  const {
    title,
    description,
    link,
    actions,
    imageResource,
    regionId = 'quickLinkCard',
  } = props;
  const firstAction = actions?.[0];
  const cardLink = firstAction?.link?.url || link?.url;
  const linkTarget =
    cardLink === firstAction?.link.url
      ? firstAction?.link.attributes?.target
      : link.attributes?.target;

  return (
    <QuickRoutedLink
      to={cardLink}
      target={linkTarget}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <LinkRegion regionId={regionId}>
        <Box pt={['s2', 's0', 's0']}>
          <QuickLinkCardFromLib
            icon={imageResource?.fileReference}
            title={title}
            description={description}
            ctaTitle={firstAction?.title}
            href={cardLink}
            alt={imageResource?.alt || ''}
          />
        </Box>
      </LinkRegion>
    </QuickRoutedLink>
  );
};

export default QuickLinkCard;
